import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function OffcanvasCreateAPICredential({ show, onHide, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    const [isChecked, setIsChecked] = React.useState(false);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Create new REST-API Credentials')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('REST-API Credentials')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API Description */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="api_description">{t('Application Name')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="api_description"
                                            defaultValue={'My Application 1'}
                                            placeholder={t('Enter Application Name')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center bg-warning">
                            <h4 className="mb-0">{t('Attention')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    <p>
                                        {t('After creating the REST-API Credential, the API Secret and ID will be displayed only once. Please make sure to save it securely as it cannot be retrieved later.')}
                                    </p>
                                </Col>
                            </Row>
                            <Form.Group className="mt-3">
                                <Form.Check
                                    type="checkbox"
                                    id="read_message_checkbox"
                                    label={t('I have read and understood the above message')}
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button
                            className="ms-2 d-end"
                            variant="primary"
                            type="submit"
                            disabled={isLoadingButton || !isChecked}
                        >
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Create new REST-API Credentials')}
                                </>
                            ) : (
                                t('Create new REST-API Credentials')
                            )}
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasCreateAPICredential;